export default "__VITE_ASSET__hEvx6eho__"